import React from 'react';
import PropTypes from 'prop-types';

import styles from './index.module.css';
import Block, {LOCATIONS} from '@components/common/block';
import Dropdown from '@components/common/dropdown';
import ScrollBlock from "@components/common/scroll-block";
import Button from "@components/common/button";
import testUiData from '../../../constants/test.json';
import utils from '@utils';

const SAMPLES_NAMES = testUiData.analysesNames;
const SAMPLES_KEYS = SAMPLES_NAMES.map(val => val.data);

function DrillingTestBlock(props) {
  return (<Block className={styles.block} header='3. Perform Test & Analysis' location={LOCATIONS.TOP}>
    <div className={styles.container}>
      <div className={styles.leftCol}>
        <Button onClick={props.drilling_onDrill} className={styles.drillButtons}>Drill</Button>
        <Button onClick={props.drilling_onPush} className={styles.drillButtons}>Direct push</Button>
        <p>After drilling or pushing, you may analyze samples below.</p>
        <Dropdown config={{ header: '', items: SAMPLES_NAMES }} onChange={props.drilling_onAnalysisSelection} value={SAMPLES_KEYS.indexOf(props.drilling_analysisValue)} />
      </div>
      <ScrollBlock className={styles.scrollBlock}>{props.resultsTxt}</ScrollBlock>
    </div>
  </Block>);
}
// Using performTest as a callback henceforth:
function ExcaTestBlock(props) {
  return (<Block className={styles.block} header='3. Perform Test' location={LOCATIONS.TOP}>
    <div className={styles.container}>
      <div className={styles.leftCol}>
        <p>After you have selected coordinates, click here to perform the test:</p>
        <Button className={styles.performTestBtn} onClick={props.onPerform}>Perform Test</Button>
      </div>
      <ScrollBlock className={styles.scrollBlock}>{props.resultsTxt}</ScrollBlock>
    </div>
  </Block>);
}

function GprTestBlock(props) {
  return (<Block className={styles.block + (props.short ? ' ' + styles.blockShort : '')} header='4. Perform Test' location={LOCATIONS.TOP}>
    <div className={styles.container}>
      <div className={styles.leftCol}>
        <p>After you have selected coordinates, click here to perform the test:</p>
        <Button className={styles.performTestBtn} onClick={props.onPerform}>Perform Test</Button>
      </div>
      <ScrollBlock className={styles.scrollBlock}>{props.resultsTxt}</ScrollBlock>
    </div>
  </Block>);
}

class MmdTestBlock extends React.Component {
  constructor(props) {
    super(props);

    this.onPerform = this.onPerform.bind(this);
    // Trying to avoid unnecessary binding in render
    this.onDrivingDirectionN = this.onDrivingDirection.bind(this, 'N');
    this.onDrivingDirectionS = this.onDrivingDirection.bind(this, 'S');
    this.onDrivingDirectionW = this.onDrivingDirection.bind(this, 'W');
    this.onDrivingDirectionE = this.onDrivingDirection.bind(this, 'E');

    this.state = {
      showingDirectionButtons: false
    };
  }

  showDirectionButtons() {
    this.setState({
      showingDirectionButtons: true
    });
  }

  onDrivingDirection(direction) {
    let param = [0, 0];

    switch(direction) {
      case 'N':
          param[1] = 10;
          break;
      case 'S':
          param[1] = -10;
          break;
      case 'W':
          param[0] = -10;
          break;
      case 'E':
          param[0] = 10;
          break;
      default:
    }
    this.props.mmd_onDrivingDirection(param);
  }

  onPerform() {
    if (this.props.mmd_onShowButtons()) {
      this.showDirectionButtons();
      this.props.onPerform();
    }
  }

  render() {
    let props = this.props;

    return (<Block className={styles.block} header='3. Perform Test' location={LOCATIONS.TOP}>
      <div className={styles.container}>
        <div className={styles.leftCol}>
          {!this.state.showingDirectionButtons && <div>
            <p>After you have selected coordinates, click here to perform the test:</p>
            <Button className={styles.performTestBtn} onClick={this.onPerform}>Begin Test</Button>
          </div>}
          {this.state.showingDirectionButtons && <div>
            <p className={styles.directionHeader}>Direction</p>
            <Button onClick={this.onDrivingDirectionW} className={styles.buttonW}>W</Button>
            <div className={styles.buttonsVertical}>
              <Button onClick={this.onDrivingDirectionN} className={styles.buttonN}>N</Button>
              <Button onClick={this.onDrivingDirectionS} className={styles.buttonS}>S</Button>
            </div>
            <Button onClick={this.onDrivingDirectionE} className={styles.buttonE}>E</Button>
          </div>}
        </div>
        <ScrollBlock className={styles.scrollBlock}>{props.resultsTxt}</ScrollBlock>
      </div>
    </Block>);
  }
}

function SgsaTestBlock(props) {
  return (<Block className={styles.block} header='3. Perform Test' location={LOCATIONS.TOP}>
    <div className={styles.container}>
      <div className={styles.leftCol}>
        <p>After you have selected coordinates, click here to perform the test:</p>
        <Button className={styles.performTestBtn} onClick={props.onPerform}>Perform Test</Button>
      </div>
      <ScrollBlock className={styles.scrollBlock}>{props.resultsTxt}</ScrollBlock>
    </div>
  </Block>);
}

function SrrTestBlock(props) {
  return (<Block className={styles.block} header='4. Perform Test' location={LOCATIONS.TOP}>
    <div className={styles.container}>
      <div className={styles.leftCol}>
        <p>After you have selected coordinates, click here to perform the test:</p>
        <Button className={styles.performTestBtn} onClick={props.onPerform}>Perform Test</Button>
      </div>
      <ScrollBlock className={styles.scrollBlock}>{props.resultsTxt}</ScrollBlock>
    </div>
  </Block>);
}

function TopoTestBlock(props) {
  return (<Block className={styles.block} header='3. Perform Test' location={LOCATIONS.TOP}>
    <div className={styles.container}>
      <div className={styles.leftCol}>
        <p>After you have selected coordinates, click here to perform the test:</p>
        <Button className={styles.performTestBtn} onClick={props.onPerform}>Perform Test</Button>
      </div>
      <ScrollBlock className={styles.scrollBlock}>{props.resultsTxt}</ScrollBlock>
    </div>
  </Block>);
}

const testComponents = {
  "drilling": DrillingTestBlock,
  "exca": ExcaTestBlock,
  "gpr": GprTestBlock,
  "mmd": MmdTestBlock,
  "sgsa": SgsaTestBlock,
  "srr": SrrTestBlock,
  "topo": TopoTestBlock
};

function PerformTestBlock(props) {
  let ChosenTest = testComponents[props.activeTest];
  let { resultsTxt, ...forwardedProps } = props;
  resultsTxt = props.resultsTxt.map((txt, idx) => <div key={idx}>{utils.multilineTextToArray(txt).map((subTxt, jdx) => <div key={jdx}>{subTxt}</div>)}</div>);
  return (<React.Fragment>
    {<ChosenTest {...forwardedProps} resultsTxt={resultsTxt} />}
  </React.Fragment>);
}

PerformTestBlock.defaultProps = {
  resultsTxt: [],
    short: false
};

PerformTestBlock.propTypes = {
  activeTest: PropTypes.string.isRequired,
  drilling_onDrill: PropTypes.func.isRequired,
  drilling_onPush: PropTypes.func.isRequired,
  drilling_onAnalysisSelection: PropTypes.func.isRequired,
  drilling_analysisValue: PropTypes.string.isRequired,
  onPerform: PropTypes.func.isRequired,
  mmd_onDrivingDirection: PropTypes.func.isRequired,
  resultsTxt: PropTypes.array,
  short: PropTypes.bool
};

export default PerformTestBlock;